export enum DOCUMENT_TYPE {
  Combo = 'ItemAccountCombo',
  ComboUpdate='ItemAccountComboUpdate',
  DistiAllocation = 'DistiAllocation',
  AccountAllocation = 'AccountAllocation',
  Allocations = 'Allocations',
  Training = 'Training',
  ItemAccountDisti = "ItemDistiCombos",
  RunningWeekAccountSettings = "RunningWeekAccSetting"
}
